module.exports = __webpack_public_path__ + "img/image6.6509cd32.png";